import { lang } from '@/lang'

const currentLang = lang.currentLang
const langfiles = require.context('./lang', true, /\.js$/)
const langfileArr = langfiles.keys().map(item => langfiles(item).default)

export default {
  zIndex: 2,
  menus: [
    'head',
    'bold',
    'fontSize',
    'fontName',
    'italic',
    'underline',
    'strikeThrough',
    'indent',
    'lineHeight',
    'foreColor',
    'backColor',
    'link',
    'list',
    'justify',
    'quote',
    'image',
    'video',
    'table',
    'code',
    'splitLine',
    'undo',
    'redo'
  ],
  lang: currentLang === 'zh' ? 'zh-CN' : currentLang,
  langTemplate: langfileArr.filter(v => v.lang === currentLang.substring(0, 2))[0].file,
  changeTimeout: 300
}
